import { createAction, props } from '@ngrx/store'
import { TutorialVideosEntity } from './tutorial-videos.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadTutorialVideos = createAction('[TutorialVideos Page] Load Tutorial Videos')

export const loadTutorialVideosSuccess = createAction(
  '[TutorialVideos/API] Load TutorialVideos Success',
  props<{ tutorialVideos: TutorialVideosEntity[] }>(),
)

export const loadTutorialVideosFailure = createAction(
  '[TutorialVideos/API] Load TutorialVideos Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectTutorialVideo = createAction(
  '[TutorialVideos Page] Select Tutorial Video',
  props<{ uuid: string | undefined }>(),
)

export const openEditTutorialVideoDialog = createAction('[TutorialVideos Page] Open Edit Tutorial Video Dialog')

export const addTutorialVideo = createAction(
  '[TutorialVideos Page] Add Tutorial Video',
  props<{ tutorialVideo: Partial<TutorialVideosEntity> }>(),
)

export const addTutorialVideoSuccess = createAction(
  '[TutorialVideos/API] Add Tutorial Video Success',
  props<{ tutorialVideo: TutorialVideosEntity }>(),
)

export const addTutorialVideoFailure = createAction(
  '[TutorialVideos/API] Add Tutorial Video Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateTutorialVideo = createAction(
  '[TutorialVideos Page] Update Tutorial Video',
  props<{ tutorialVideo: Partial<TutorialVideosEntity> }>(),
)

export const updateTutorialVideoSuccess = createAction(
  '[TutorialVideos/API] Update Tutorial Video Success',
  props<{ tutorialVideo: TutorialVideosEntity }>(),
)

export const updateTutorialVideoFailure = createAction(
  '[TutorialVideos/API] Update Tutorial Video Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteTutorialVideo = createAction(
  '[TutorialVideos Page] Delete Tutorial Video',
  props<{ uuid: string }>(),
)

export const deleteTutorialVideoSuccess = createAction(
  '[TutorialVideos/API] Delete Tutorial Video Success',
  props<{ uuid: string }>(),
)

export const deleteTutorialVideoFailure = createAction(
  '[TutorialVideos/API] Delete Tutorial Video Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const showTutorialPopUpVideo = createAction(
  '[TutorialVideos/API] Show Tutorial PopUp Video',
  props<{ videos: TutorialVideosEntity[]; target: string }>(),
)
export const hideTutorialPopUpVideo = createAction('[TutorialVideos/API] Hide Tutorial PopUp Video')
